<script>
import AppDisplay from '@/components/AppDisplay.vue'
import Bioinsumos from '../components/Bioinsumos.vue'
import Irrigacao from '../components/Irrigacao.vue'
import Financiamento from '../components/Financiamento.vue'
import Descricao from '../components/Descricao.vue'
import { formataStringYearMonthToBr } from '@/utils/utils'
import { opcoesEspeciesFlorestaisSaf, opcoesEspeciesFrutiferas, opcoesEspeciesCicloCurto, opcoesEspeciesAdubadeiras } from '@/libs/constants/praticas/opcoesSelects'

export default {
  components: {
    AppDisplay,
    Bioinsumos,
    Irrigacao,
    Financiamento,
    Descricao
  },
  props: {
    pratica: {
      type: Object
    }
  },
  methods: {
    formataDataInicio (value) {
      if (!value) return ''
      return formataStringYearMonthToBr(value)
    },
    getEspecies (tipoEspecie, especie) {
      if (tipoEspecie === 'ESPECIE_FLORESTAL') return opcoesEspeciesFlorestaisSaf.find(e => e.id === especie).nome
      if (tipoEspecie === 'ESPECIE_FRUTIFERA') return opcoesEspeciesFrutiferas.find(e => e.id === especie).nome
      if (tipoEspecie === 'ESPECIE_ALIMENTAR_CICLO_CURTO_E_MEDIO') return opcoesEspeciesCicloCurto.find(e => e.id === especie).nome
      if (tipoEspecie === 'ESPECIE_ADUBEIRAS_OU_DE_SERVICO') return opcoesEspeciesAdubadeiras.find(e => e.id === especie).nome
    },
    formataEspecies (tipoEspecie, especies) {
      if (!especies) return ''
      const especiesFormatadas = especies.filter(e => e.tipo === tipoEspecie).map(e => {
        if (e.especie === 'OUTROS') {
          return `• Espécie: ${e.especificacao} / Espaçamento: ${e.espacamento}`
        }
        return `• Espécie: ${this.getEspecies(tipoEspecie, e.especie)} / Espaçamento: ${e.espacamento}`
      })
      return especiesFormatadas.join('<br/> ')
    }
  }
}
</script>

<template>
  <div>
    <div>
      <span class="title-praticas">Dados da prática</span>
      <hr />
    </div>
    <el-row>
      <el-col :span="12">
        <app-display label="Área (ha):" :content="pratica.area" />
        <app-display label="Espécies florestais:" :content="formataEspecies('ESPECIE_FLORESTAL', pratica.especies)" :isContentInNextLine="true" />
        <app-display label="Espécies frutíferas:" :content="formataEspecies('ESPECIE_FRUTIFERA', pratica.especies)" :isContentInNextLine="true" />
      </el-col>
      <el-col :span="12">
        <app-display label="Data de início da implementação (mês e ano):" :content="formataDataInicio(pratica.dataInicio)" />
        <app-display label="Espécies alimentares de ciclo curto e médio:" :content="formataEspecies('ESPECIE_ALIMENTAR_CICLO_CURTO_E_MEDIO', pratica.especies)" :isContentInNextLine="true" />
        <app-display label="Espécies adubadeiras ou de serviço:" :content="formataEspecies('ESPECIE_ADUBEIRAS_OU_DE_SERVICO', pratica.especies)" :isContentInNextLine="true" />
      </el-col>
    </el-row>
    <Bioinsumos :bioinsumo="{utilizaBioinsumos: pratica.utilizaBioinsumos, bioinsumos: pratica.bioinsumos}" />
    <Irrigacao :irrigacao="{possuiIrrigacao: pratica.possuiIrrigacao, ...pratica.irrigacao}" />
    <Financiamento :financiamento="{financiamentos: pratica.financiamentos, outroFinanciamento: pratica.outroFinanciamento}" />
    <Descricao :descricao="pratica.descricao" />
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/SAF/SAF.vue